import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { fg } from '@confluence/feature-gating';
import { preloadAIFCOnboardingStateForTopNav } from '@confluence/onboarding-helpers/entry-points/preloadAIFCOnboardingStateForTopNav';

import { TopNavigationQuery } from './TopNavigationQuery.graphql';
import { preloadUnseenNotificationCount } from './preloadNotificationCount';

export async function preloadTopNavigation() {
	const { userId } = getPreloaderFnContext();

	const topNavigationPromises = [
		query({
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query: TopNavigationQuery,
			variables: {
				includeNav4AdminOptIn: fg('confluence_nav4_ga_phase_1'),
			},
		}),
	];

	if (fg('aifc_create_enabled')) {
		topNavigationPromises.push(preloadAIFCOnboardingStateForTopNav());
	}

	if (userId && fg('confluence_frontend_preload_notifications')) {
		//skip for anon
		topNavigationPromises.push(preloadUnseenNotificationCount());
	}

	return waitForAllReturnWhenError(topNavigationPromises);
}
